export default __webpack_public_path__ + "static/media/Flm0BjraYAEE6UY.5b1cb49e.jpg";